import {getQuotePriceWithTaxes, getTotalPrice, toFixedFeatureCost} from "./misc/helpers";
import store from "./store";
import {getAllFeatureFilters, getFilterGroupValue} from "./misc/utils";
import {filterCartItems, getDbFeatureProperty} from "./bvcomponents/look/lookNavigation/lookFunctions2";


export const getAnalyticsEcommerceItem = (feature, quantity = 1, index = 0) => {
  if (!feature) {
    return false
  }
  const {fabricatorState, filterState} = store.getState();
  const {filterGroups} = filterState;

  let item_brand = "";
  const manufacturerFilterGroup = filterGroups.find(filterGroup => filterGroup.name.trim() === "Manufacturer");
  if (manufacturerFilterGroup) {
    const featureFilters = getAllFeatureFilters(feature);
    if (featureFilters && Array.isArray(featureFilters[manufacturerFilterGroup.id]) && featureFilters[manufacturerFilterGroup.id].length) {
      const filterValueObject = getFilterGroupValue(featureFilters[manufacturerFilterGroup.id][0], manufacturerFilterGroup)
      if (filterValueObject) {
        item_brand = filterValueObject.displayText;
      }
    }
  }

  const featureGroup = feature.getParent();
  const itemQuantity = Number.isInteger(quantity) ? quantity : 1;

  return {
    item_id: feature.dbFeature.sku, // "SKU_12345"
    item_name: feature.getCustomFullDisplayName(), // "Stan and Friends Tee",
    affiliation: fabricatorState.companyName || "", // "Google Merchandise Store",
    coupon: "", // "SUMMER_FUN", // we never have any
    discount: 0.00, // 2.22 // we are not using them yet
    index,
    item_brand, // "Google", // Manufacturer filter
    item_category: feature.dbFeature[getDbFeatureProperty("lixilProductCategory")] || "", // "Apparel",
    item_category2: feature.dbFeature[getDbFeatureProperty("lixilProductSubCategory")] || "", // "Adult",
    item_category3: feature.getCollectionName(filterGroups), // "Shirts",
    item_category4: "", // "Crew",
    item_category5: "", // "Short sleeve",
    item_list_id: feature.partId, // "related_products",
    item_list_name: featureGroup.dbName || featureGroup.partName || "", //"Related Products",
    item_variant: feature.getColorName(filterGroups), // "green",
    location_id: "", // "ChIJIQBpAG2ahYAR_6128GcTUEo",
    price: +toFixedFeatureCost(feature, itemQuantity),
    quantity: itemQuantity
  }
}

export const getAnalyticsEcommerceValues = (cartItemsToCount) => {
  const {cartState, fabricatorState} = store.getState();
  const cartItems = cartItemsToCount || cartState.cartItems;
  const fabricatorSettings = fabricatorState.settings;

  const cartItemsToInclude = filterCartItems(cartItems);
  const totalPrice = getTotalPrice(null, false, cartItemsToInclude);

  const tax = totalPrice.priceTaxes.length
    ? totalPrice.priceTaxes.reduce((acc, tax) => acc + tax.materialTax, 0)
    : totalPrice.materialTaxes

  return {
    currency: fabricatorSettings.currency,
    value: getQuotePriceWithTaxes(totalPrice),
    items: cartItemsToInclude.map((cartItem, cartItemIndex) => {
      return getAnalyticsEcommerceItem(cartItem.cartFeature, cartItem.quantity, cartItemIndex)
    }),
    tax: tax || 0,
    shipping: totalPrice.totalDeliveryCost || 0,
  }
}
